import { render, staticRenderFns } from "./patientSettings.vue?vue&type=template&id=179c7a13&scoped=true"
import script from "./patientSettings.vue?vue&type=script&lang=js"
export * from "./patientSettings.vue?vue&type=script&lang=js"
import style0 from "./patientSettings.vue?vue&type=style&index=0&id=179c7a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179c7a13",
  null
  
)

export default component.exports